import { Money } from "@redotech/money";
import { moneyFormat } from "@redotech/money/util";
import { RedoButton } from "@redotech/redo-web/arbiter-components/buttons/redo-button";
import { ImageDisplayWithPlaceholder } from "@redotech/redo-web/image-display-with-placeholder";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";

export interface MarketplaceProductListingProps {
  imageUrl: string;
  imageAlt?: string;
  title: string;
  price: Money;
  onClick?: () => void;
  onAddToCart?: () => void;
  isInCart?: boolean;
  className?: string;
}

export const MarketplaceProductListing = memo(
  function MarketplaceProductListing({
    imageUrl,
    imageAlt,
    title,
    price,
    onClick,
    onAddToCart,
    isInCart = false,
    className,
  }: MarketplaceProductListingProps) {
    return (
      <div
        className={`cursor-pointer w-[200px] ${className || ""}`}
        onClick={onClick}
      >
        <div className="w-[200px] h-[200px] overflow-hidden bg-gray-50 rounded-sm mb-3 border border-gray-200">
          <ImageDisplayWithPlaceholder
            alt={imageAlt || title}
            className="h-full w-full object-cover"
            src={imageUrl}
          />
        </div>

        <Text
          className="line-clamp-2 leading-tight mb-1"
          fontSize="sm"
          fontWeight="semibold"
        >
          {title}
        </Text>

        <Text fontSize="sm" textColor="tertiary">
          {moneyFormat(price)}
        </Text>

        {onAddToCart && (
          <div className="mt-2">
            <RedoButton
              hierarchy="secondary"
              onClick={(e) => {
                e.stopPropagation();
                if (!isInCart) {
                  onAddToCart();
                }
              }}
              size="xs"
              text={isInCart ? "In Cart" : "Add to Cart"}
            />
          </div>
        )}
      </div>
    );
  },
);
